import request from '@/utils/request'
import qs from 'qs'
export function getCheckoutList(query) {
  return request({
    url: '/report-service/v1/checkout-report/list',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    }
  })
}
export function getCheckoutExcel(query) {
  return request({
    url: '/report-service/v1/checkout-report/listExcel',
    method: 'get',
    params: query,
    paramsSerializer: query => {
      return qs.stringify(query, {
        arrayFormat: 'repeat',
        encode: false
      })
    },
    responseType: 'blob'
  })
}
